// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.wob-mapviewhistory-description {
    font-style: italic;
    padding-bottom: 0.5em;
}

div.WobMapViewHistory button.forward-button > .icon {
    order: 1;
    margin-right: 0em;
    margin-left: 0.25em;
}
`, "",{"version":3,"sources":["webpack://./qwc2-wob/plugins/style/MapViewHistory.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;AACvB","sourcesContent":["div.wob-mapviewhistory-description {\n    font-style: italic;\n    padding-bottom: 0.5em;\n}\n\ndiv.WobMapViewHistory button.forward-button > .icon {\n    order: 1;\n    margin-right: 0em;\n    margin-left: 0.25em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
